import { render, staticRenderFns } from "./uploadBase.vue?vue&type=template&id=3a2ce7a0&"
import script from "./uploadBase.vue?vue&type=script&lang=js&"
export * from "./uploadBase.vue?vue&type=script&lang=js&"
import style0 from "./uploadBase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports